import DosingRow from 'components/DosingRow/DosingRow';
import DosingTitle from 'forms/DosingInfo/DosingTitle/DosingTitle';

const FixedDosing = () => {
  return (
    <div
      className="tab-pane dosing-form-container"
      id="pills-fixed-2"
      role="tabpanel"
      aria-labelledby="pills-fixed-tab-2"
    >
      <DosingTitle
        title="Fixed XYWAV Dosing"
        subtitle="2 times a night dosing (For IH)"
      />

      <DosingRow
        fields={{
          doses: ['rems:fixedDosing:ih:dose'],
        }}
        mobileFullWidth
      />
    </div>
  );
};

export default FixedDosing;
